import styled from "styled-components";
import { COLORS } from "../../../../../../styles/constants.style";

export const CreateGenericAccountCheckboxWrapper = styled.div`
  padding: 24px 16px;

  .section-container {
    padding: 0px 16px;
    margin-top: 24px;
    width: 100%;
  }

  .section-container:not(:last-child) {
    border-bottom: 2px dashed ${COLORS.primary_light_blue};
  }

  .checkbox-container {
    padding: 24px 0px;
    row-gap: 20px;
  }

  .mainTitle {
    padding: 8px 16px;
    border-bottom: 2px dashed ${COLORS.primary_light_blue};
    width: 100%;
    display: flex;
  }
`;
